export const blockMixin = {

    methods: {
        numberWithDots: function(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        sum: function( obj, key) {
            var sum = 0;
            for( var el in obj ) {
                
                sum += parseFloat( obj[el][key] );
                
            }
            return sum;
        },
            
        gbo: function(blockID) {
            var base = this.specs[this.type];
            let localsum = 0;
            if (parseInt(this.$store.getters.blockById(blockID).aantallen.beukmaat51)) {localsum += parseInt(this.$store.getters.blockById(blockID).aantallen.beukmaat51) * parseInt(this.$store.getters.blockById(blockID).display.beukmaat51) * base['5100'][0]};
            if (parseInt(this.$store.getters.blockById(blockID).aantallen.beukmaat54)) {localsum += parseInt(this.$store.getters.blockById(blockID).aantallen.beukmaat54) * parseInt(this.$store.getters.blockById(blockID).display.beukmaat54) * base['5400'][0]};
            if (parseInt(this.$store.getters.blockById(blockID).aantallen.beukmaat57)) {localsum += parseInt(this.$store.getters.blockById(blockID).aantallen.beukmaat57) * parseInt(this.$store.getters.blockById(blockID).display.beukmaat57) * base['5700'][0]};
            if (parseInt(this.$store.getters.blockById(blockID).aantallen.beukmaat60)) {localsum += parseInt(this.$store.getters.blockById(blockID).aantallen.beukmaat60) * parseInt(this.$store.getters.blockById(blockID).display.beukmaat60) * base['6000'][0]};
            return localsum;
        },
        bi: function() {
            var base = this.specs[this.type];
            let localsum = 0;
            if (parseInt(this.configdata.aantallen.beukmaat51)) {localsum += parseInt(this.configdata.aantallen.beukmaat51) * parseInt(this.configdata.display.beukmaat51) * base['5100'][1]};
            if (parseInt(this.configdata.aantallen.beukmaat54)) {localsum += parseInt(this.configdata.aantallen.beukmaat54) * parseInt(this.configdata.display.beukmaat54) * base['5400'][1]};
            if (parseInt(this.configdata.aantallen.beukmaat57)) {localsum += parseInt(this.configdata.aantallen.beukmaat57) * parseInt(this.configdata.display.beukmaat57) * base['5700'][1]};
            if (parseInt(this.configdata.aantallen.beukmaat60)) {localsum += parseInt(this.configdata.aantallen.beukmaat60) * parseInt(this.configdata.display.beukmaat60) * base['6000'][1]};
            return localsum;
        },
        price: function() {
            if (this.configdata.verschijningsvorm === '2 en 3 lagen met plat dak gecombineerd') {
                var cascoprice = 0;
                if (this.type === '202') { /* 8,9 meter */
                cascoprice += parseInt(this.configdata.aantallen.drielagen) * this.prices.types['202']['5400'][0];
                cascoprice += parseInt(this.configdata.aantallen.tweelagen) * this.prices.types['200']['5400'][0];
                }
                else { /* 9,5 meter */
                cascoprice += parseInt(this.configdata.aantallen.drielagen) * this.prices.types['302']['5400'][0];
                cascoprice += parseInt(this.configdata.aantallen.tweelagen) * this.prices.types['300']['5400'][0];
                }
                ;
            }
            else {
                var baseprice = this.prices.types[this.type];
                var cascoprice = 0;
                if (parseInt(this.configdata.display.beukmaat51)) {cascoprice += parseInt(this.configdata.aantallen.beukmaat51) * parseInt(this.configdata.display.beukmaat51) * baseprice['5100'][0]};
                if (parseInt(this.configdata.display.beukmaat54)) {cascoprice += parseInt(this.configdata.aantallen.beukmaat54) * parseInt(this.configdata.display.beukmaat54) * baseprice['5400'][0]};
                if (parseInt(this.configdata.display.beukmaat57)) {cascoprice += parseInt(this.configdata.aantallen.beukmaat57) * parseInt(this.configdata.display.beukmaat57) * baseprice['5700'][0]};
                if (parseInt(this.configdata.display.beukmaat60)) {cascoprice += parseInt(this.configdata.aantallen.beukmaat60) * parseInt(this.configdata.display.beukmaat60) * baseprice['6000'][0]};
                console.log(cascoprice);
            }
            var options = parseInt(this.configdata.aantallen.aanbouw12) * parseInt(this.prices.options.aanbouw12) + 
                            parseInt(this.configdata.aantallen.aanbouw24) * parseInt(this.prices.options.aanbouw24) + 
                            parseInt(this.configdata.aantallen.slaapzolder) * parseInt(this.prices.options.slaapzolder) + 
                            parseInt(this.configdata.aantallen.tuitgevel) * parseInt(this.prices.options.tuitgevel) + 
                            parseInt(this.numberOfHouses) * parseInt(this.prices.options.bad) * (this.configdata.opties.bad == 'Ja' ? 1 : 0) + 
                            parseInt(this.numberOfHouses) * parseInt(this.prices.options.tweedetoilet) * (this.configdata.opties.tweedetoilet == 'Ja' ? 1 : 0) + 
                            parseInt(this.numberOfHouses) * parseInt(this.prices.options.wittedakplaten) * (this.configdata.opties.wittedakplaten == 'Ja' ? 1 : 0) * parseInt(this.configdata.display.wittedakplaten) +
                            parseInt(this.configdata.aantallen.llb1slaapkamer) * parseInt(this.prices.options.extraslaapkamerllb) * parseInt(this.configdata.display.slaapkamerllb) +
                            parseInt(this.configdata.aantallen.llb2slaapkamer) * parseInt(this.prices.options.extraslaapkamerllb) * 2 * parseInt(this.configdata.display.slaapkamerllb) +
                            parseInt(this.numberOfHouses) * parseInt(this.prices.options.nom) * (this.configdata.opties.nom == 'Ja' ? 1 : 0);
            switch(this.configdata.opties.sanitair) {
                case 'Luxe' : options += (parseInt(this.numberOfHouses) * this.prices.options.sanitair.luxe); break;
                case 'Excellent' : options += (parseInt(this.numberOfHouses) * this.prices.options.sanitair.excellent); break;
            }
            switch(this.configdata.opties.douchewand) {
                case 'Glazen douchewand' : options += (parseInt(this.numberOfHouses) * this.prices.options.douchewand.douchewandGlas); break;
                case 'Glazen douchewand + deur' : options += (parseInt(this.numberOfHouses) * this.prices.options.douchewand.douchewandGlasDeur); break;
            }
            switch(this.configdata.opties.wandafwerking) {
                case 'Sausklaar' : options += (parseInt(this.numberOfHouses) * this.prices.options.wandafwerking.sausklaar); break;
                case 'Scanbehang' : options += (parseInt(this.numberOfHouses) * this.prices.options.wandafwerking.scanbehang); break;
            }
            switch(this.configdata.opties.heipalen) {
                case '15 meter' : options += (parseInt(this.numberOfHouses) * this.prices.options.heipalen['15']); break;
                case '20 meter' : options += (parseInt(this.numberOfHouses) * this.prices.options.heipalen['20']); break;
            }

            var total = cascoprice + options;
            console.log(options);
            if (this.configdata.opties.startjaar == '2021') {
                return Math.round(total / 1.03 * 1.015);
            }
            return total;
        },
        numberOfHouses: function() {
            return parseInt(this.configdata.aantallen.beukmaat51) * parseInt(this.configdata.display.beukmaat51) + 
            parseInt(this.configdata.aantallen.beukmaat54) * parseInt(this.configdata.display.beukmaat54) +
            parseInt(this.configdata.aantallen.beukmaat57) * parseInt(this.configdata.display.beukmaat57) +
            parseInt(this.configdata.aantallen.beukmaat60) * parseInt(this.configdata.display.beukmaat60);
        },
        totalLength: function() {
            return (parseInt(this.configdata.aantallen.beukmaat51) * 5.1 + 
                    parseInt(this.configdata.aantallen.beukmaat54) * 5.4 + 
                    parseInt(this.configdata.aantallen.beukmaat57) * 5.7 + 
                    parseInt(this.configdata.aantallen.beukmaat60) * 6.0 +
                    0.6).toFixed(1).replace('.',',')
        },
        average: function() {
            return Math.round(this.price / this.numberOfHouses);
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/block.js